import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';
import BaseRolePerimeter from '@/kindergarten/perimeters/BaseRolePerimeter';
import GuestPerimeter from '@/kindergarten/perimeters/GuestPerimeter';
import AuthPerimeter from '@/kindergarten/perimeters/AuthPerimeter';
import DriverPerimeter from '@/kindergarten/perimeters/DriverPerimeter';
import KitchenPerimeter from '@/kindergarten/perimeters/KitchenPerimeter';
import EmployeePerimeter from '@/kindergarten/perimeters/EmployeePerimeter';

export const perimeters = {
  BasePerimeter,
  GuestPerimeter,
  AuthPerimeter,
  BaseRolePerimeter,
  DriverPerimeter,
  KitchenPerimeter,
  EmployeePerimeter,
};

export const redirectRoutes = {
  GuestPerimeter: 'my-account.index',
  DriverPerimeter: 'my-account.index',
  KitchenPerimeter: 'my-account.index',
  EmployeePerimeter: 'my-account.index',
  AuthPerimeter: 'login.index',
  BaseRolePerimeter: 'my-account.index',
};



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/index.js